import * as React from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';

import { Button, ButtonContainer, ModalFooter } from '@emburse/ui-core';

import { Icon } from '@ReactComponents/Icon';
import { ManualUploadCardProgramPanelKeys } from '@ReactComponents/ManualUploadCardProgramModal';
import { IWizardPanelProps, WizardPanel } from '@ReactComponents/Wizard/Wizard';

import { ReviewCardHolders, UpdateAddCardDiffCardHolder } from '@Actions/index';
import { IAppStateContainer } from '@Reducers/index';

import { IAddCardDiff, IAddTransactionDiff } from '@Shared/card_statement_upload';
import { ILinkedAccountModel, IUserModel } from '@Shared/models';

import { ManualUploadSingleCardHolderMapping } from '../ManualUploadSingleCardHolderMapping';

// Styles
import * as style from './ManualUploadCardProgramCardMapping.styl';

interface IManualUploadCardProgramCardMappingProps {
  userId?: string;
  addCardDiffs: IAddCardDiff[];
  addTransactionDiffs: IAddTransactionDiff[];
  users: IUserModel[];
  cardProgram: ILinkedAccountModel;
  onChangeCardHolder: (temporaryAccountId: string, userId: string) => void;
  onReview: () => void;
  onBackout: () => void;
}

interface IManualUploadCardProgramCardMappingState {
  programName: string;
}

export class ManualUploadCardProgramCardMapping extends WizardPanel<
  ManualUploadCardProgramPanelKeys,
  IManualUploadCardProgramCardMappingProps,
  IManualUploadCardProgramCardMappingState
> {
  constructor(props: IWizardPanelProps<ManualUploadCardProgramPanelKeys> & IManualUploadCardProgramCardMappingProps) {
    super(props);
  }

  onReview() {
    this.props.onReview();
    this.props.changePanel('summary');
  }

  onBackout() {
    this.props.onBackout();
    this.props.changePanel('start');
  }

  render() {
    const cardProgram = this.props.cardProgram;
    const onChangeCardHolder = this.props.onChangeCardHolder;
    const countCurrentCardHolders = (cardProgram.subaccounts && cardProgram.subaccounts.length) || 0;
    const addCardDiffs = this.props.addCardDiffs;
    const addTransactionDiffs = this.props.addTransactionDiffs;
    const users = this.props.users;
    const mappingComponents = addCardDiffs.map(function (cardDiff) {
      const countOfNewTransactions = addTransactionDiffs.filter(function (transactionDiff) {
        return transactionDiff.accountId === cardDiff.id;
      }).length;
      return (
        <ManualUploadSingleCardHolderMapping
          key={cardDiff.id}
          addCardDiff={cardDiff}
          users={users}
          countOfNewTransactions={countOfNewTransactions}
          onChangeCardHolder={(user) => onChangeCardHolder(cardDiff.id, user.id)}
        />
      );
    });

    const noun = mappingComponents.length === 1 ? 'card holder' : 'card holders';
    return (
      <div className={style.global}>
        <div>
          <p>
            This program currently has <strong>{countCurrentCardHolders}</strong> card holders. We identified{' '}
            <strong>{mappingComponents.length}</strong> new {noun} from the statement you uploaded. Please review and correct any
            information below.
          </p>
          {mappingComponents}
        </div>

        <ModalFooter>
          <ButtonContainer alignButtons="right">
            <Button variant="outlined" onClick={() => this.onBackout()}>
              Back
            </Button>

            <Button primary onClick={() => this.onReview()}>
              Review Transactions
              <Icon small name="right-arrow-small" />
            </Button>
          </ButtonContainer>
        </ModalFooter>
      </div>
    );
  }
}

// Connected Component

const mapStateToProps = (state: IAppStateContainer, parentProps: IWizardPanelProps<ManualUploadCardProgramPanelKeys>) => {
  const s = state.cardStatementUpload;
  const users = state.users.users;
  return {
    ...parentProps,
    users,
    error: s.error,
    allDiffs: s.allDiffs,
    addCardDiffs: s.addCardDiffs,
    addTransactionDiffs: s.addTransactionDiffs,
    errorDiffs: s.errorDiffs
  };
};

const mapDispatchToProps = (dispatch: (action: AnyAction) => void) => ({
  onChangeCardHolder: (temporaryAccountId: string, userId: string) => {
    dispatch(new UpdateAddCardDiffCardHolder(temporaryAccountId, userId));
  },
  onReview: () => dispatch(new ReviewCardHolders(true)),
  onBackout: () => dispatch(new ReviewCardHolders(false))
});

export const ConnectedManualUploadCardProgramCardMapping = connect(mapStateToProps, mapDispatchToProps)(ManualUploadCardProgramCardMapping);
